import { Box, Typography, Chip, Stack } from '../../../imports/muiImport';
import RedeemableProduct from '../redeemableProducts/RedeemableProduct';
import ProductDetailPara from './ProductDetailPara';
import { useSelector } from 'react-redux';
import MarkdownRenderer from './MarkdownRenderer';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { normalizeContent } from '../../../hooks/utilsFn/utilsFn';

function MobileProductDetails({ product }) {
  const PRODUCTDETAILS = useSelector((state) => state.ProductDetail?.allData);
  return (
    <Box
      mt={0}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: '100%',
        px: 2,
        pt: 2,
      }}
    >
      <Typography
        variant="h1"
        sx={{
          color: 'text.primary',
          fontSize: { xs: '4.5vw', sm: '2.5vw' },
          fontWeight: 500,
          textAlign: 'center',
          overflowWrap: 'break-word',
          wordBreak: 'break-word',
          mb: 2,
          px: 2,
        }}
      >
        {product?.title}
      </Typography>

      <Chip
        label={`${PRODUCTDETAILS?.discount}% ${PRODUCTDETAILS?.productType}`}
        sx={{
          px: '4px',
          backgroundColor: 'primary.main',
          color: 'white.main',
          fontSize: {
            xs: '3.8vw',
            sm: '2vw',
          },
          boxShadow: 6,
          mb: 1,
        }}
      />

      <Box
        sx={{
          py: 2,
          borderRadius: 3,
          display: 'flex',
          justifyContent: 'flex-start',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="body1"
          sx={{
            mb: 1,
            color: 'text.primary',
            fontSize: {
              xs: '4.1vw',
              sm: '2vw',
            },
            fontWeight: 500,
            textTransform: 'capitalize',
          }}
        >
          Redeemable at:
        </Typography>
        <RedeemableProduct store={product?.store} website={product?.website} />
        <Typography
          variant="h2"
          sx={{
            mt: 2,
            color: 'textPrimary.main',
            fontSize: {
              xs: '3.1vw',
              sm: '2vw',
            },
          }}
        >
          *Terms & Condtions apply
        </Typography>
      </Box>

      <ProductDetailPara productDescription={normalizeContent(product?.description)} />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          rowGap: 3,
          maxWidth: '100%',
        }}
      >
        {product?.redeem?.length > 0 && (
          <Stack direction="column" sx={{ borderBottom: 1, borderColor: 'borderColor.main' }}>
            <Typography
              variant="h2"
              sx={{
                color: 'primary.main',
                fontSize: '1.225rem',
                textAlign: 'left',
                fontWeight: 500,
              }}
            >
              How to Redeem
            </Typography>

            <MarkdownRenderer content={product?.redeem} />
          </Stack>
        )}

        {product?.terms?.length > 0 && (
          <Stack direction="column" sx={{ borderBottom: 1, borderColor: 'borderColor.main' }}>
            <Typography
              variant="h2"
              sx={{
                color: 'primary.main',
                fontSize: '1.225rem',
                textAlign: 'left',
                fontWeight: 500,
              }}
            >
              Terms & Condtions
            </Typography>
            <MarkdownRenderer content={product?.terms} />
          </Stack>
        )}

        {/* {product?.['moreInfo']?.length > 0 && (
          <Stack direction="column">
            <Typography
              variant="h2"
              sx={{
                color: 'primary.main',
                fontSize: '1.225rem',
                textAlign: 'left',
                fontWeight: 500,
              }}
            >
              More Info
            </Typography>
            <MarkdownRenderer content={product?.['moreInfo']} />
          </Stack>
        )} */}

        {product?.['moreInfo']?.length > 0 && (
          <Accordion sx={{ boxShadow: 'none', border: '1px solid #f1f1f1' }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="more-info-content"
              id="more-info-header"
              sx={{
                bgcolor: '#f5f5f5',
                px: 2,
              }}
            >
              <Typography
                sx={{
                  color: 'text.primary',
                  fontSize: '1.125rem',
                  fontWeight: 500,
                }}
              >
                More About {product?.title || 'Gift Vouchers'}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 2, py: 1 }}>
              <MarkdownRenderer content={product?.['moreInfo']} />
            </AccordionDetails>
          </Accordion>
        )}
      </Box>
    </Box>
  );
}

export default MobileProductDetails;
